export default __webpack_public_path__ + "static/media/blackjack.fe0768da.png";